/* ============================================================
   CATERPY テクノロジーセクション
   - タブ切替
   - HOW TOクリックでメイン動画差し替え（再クリックで戻る）
   - 「再生中」の文言が未設定の場合、カードごと非表示にして詰める
   - その場合、動画クリックでメイン動画に戻せるようにする
   ============================================================ */

(function () {
  'use strict';

document.querySelectorAll('.caterpy-tech').forEach(function (section) {
    initTabs(section);
    initHowtoToggle(section);
  });

  /* タブ切替 */  function initTabs(section) {
    var tabs = section.querySelectorAll('.caterpy-tech__tab');
    var panels = section.querySelectorAll('.caterpy-tech__panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-tab-target');

        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        panels.forEach(function (p) {
          if (p.getAttribute('data-tab-panel') === target) {
            p.classList.add('is-active');
            var v = p.querySelector('video[data-video-player]');
            if (v) {
              v.play().catch(function () { });
            }
          } else {
            p.classList.remove('is-active');
            var v2 = p.querySelector('video[data-video-player]');
            if (v2) { v2.pause(); }
          }
        });
      });
    });
  }

  /* HOW TOカードクリックでメイン動画差し替え（トグル式） */
  function initHowtoToggle(section) {
    section.querySelectorAll('[data-howto-trigger]').forEach(function (trigger) {

      // 動画未設定時は何もしない
      if (trigger.hasAttribute('disabled') || !trigger.getAttribute('data-howto-src')) {
        return;
      }

      var hasActiveContent = trigger.getAttribute('data-has-active-content') === 'true';
      var targetId = trigger.getAttribute('data-target-player');
      var player = section.querySelector('video[data-video-player="' + targetId + '"]');

      trigger.addEventListener('click', function () {
        toggleHowto(trigger, player, hasActiveContent);
      });

      // 「再生中カードが非表示」のケースの救済策：動画クリックでメイン動画に戻す
      if (player && !hasActiveContent) {
        player.addEventListener('click', function () {
          if (trigger.classList.contains('is-active')) {
            toggleHowto(trigger, player, hasActiveContent);
          }
        });
      }
    });
  }

  /* トグル本体：動画差し替え＋カード内文言の切り替え＋（未設定時）カード自体の表示切替 */
  function toggleHowto(trigger, player, hasActiveContent) {
    if (!player) { return; }

    var isHowtoActive = trigger.classList.contains('is-active');
    var willBeActive = !isHowtoActive;

    var howtoSrc = trigger.getAttribute('data-howto-src');
    var mainSrc = trigger.getAttribute('data-main-src');
    var nextSrc = isHowtoActive ? mainSrc : howtoSrc;
    var currentSource = player.querySelector('source');
    if (currentSource && nextSrc) {
      currentSource.setAttribute('src', nextSrc);
      player.load();
      player.play().catch(function () { });
    }

    trigger.classList.toggle('is-active');

    if (hasActiveContent) {
      // 再生中の文言が設定されている場合：テキストを切り替える
      toggleRole(trigger, 'howto-label-default', 'howto-label-active', willBeActive);
      toggleRole(trigger, 'howto-title-default', 'howto-title-active', willBeActive);
      toggleRole(trigger, 'howto-desc-default', 'howto-desc-active', willBeActive);
      toggleRole(trigger, 'howto-cta-default', 'howto-cta-active', willBeActive);
    } else {
      // 再生中の文言が未設定の場合：カードごと非表示にして詰める
      trigger.hidden = willBeActive;
    }
  }

  /* data-role属性を持つ2要素を、状態に応じて表示/非表示切替 */
  function toggleRole(scope, defaultRole, activeRole, showActive) {
    var defaultEl = scope.querySelector('[data-role="' + defaultRole + '"]');
    var activeEl = scope.querySelector('[data-role="' + activeRole + '"]');
    if (defaultEl) { defaultEl.hidden = showActive; }
    if (activeEl) { activeEl.hidden = !showActive; }
  }
})();